import models from '../models'
import cloneDeep from 'lodash/cloneDeep'
import isPlainObject from 'lodash/isPlainObject'

const isObject = obj => obj && typeof obj === 'object' && !Array.isArray(obj);

// 深度合并，针对不同的类型，拷贝一份prop，然后设置在value上
function mergeDeep(prev, obj) {
  // console.log('ccc', prev, obj)
  // 遍历对象的属性
  Object.keys(obj).forEach(key => {
    // 没有属性，则创造一个
    if (!prev.props) prev.props = {}
    if (!prev.props[key]) {
      prev.props[key] = {
        name: key,
        nickname: key,
        type: 'robot',
        isUsed: true,
        desc: key,
      }
    }
    const pVal = prev.props[key];
    let oVal = obj[key];

    // 这里做个标识，标识在解析的时候，echarts的options中有这个属性
    pVal.existInEchartsOptions = true

    if (pVal.type === 'robot') { // 模型没有配置的，直接当做value处理
      pVal.value = oVal
    } else if (pVal.type === 'pureValue') {
      pVal.value = oVal
    } else if (pVal.type === 'richMap') {
      pVal.isUsed = true // 标记已经被使用
      // 对象变数组 { a: { b: 1 } } => [{ primaryKey: a, b: 1}] 
      oVal = Object.keys(oVal).reduce((val, key) => {
        const richMapPKeyObj = Object.values(pVal.props).find(item => item.richMapPrimaryKey)
        const arrItem = {
          [richMapPKeyObj.name]: key,
          ...oVal[key],
        }
        val.push(arrItem)
        return val
      }, [])
      pVal.value = oVal.map(item => { // 复杂的则拷贝默认属性值，然后和数据进行合并
        const data = cloneDeep(pVal.props)
        const newData = mergeDeep({
          props: data,
          type: 'object',
        }, item)
        return newData
      })
    } else if (Array.isArray(oVal)) {
      pVal.isUsed = true
      if (!pVal.type) pVal.type === 'array' // 默认普通数组
      if (pVal.type === 'typeArray') { // series是个typeArray，典型案例
        pVal.isUsed = true
        if (!pVal.props) pVal.props = {}
        pVal.value = oVal.map(item => { // 复杂的则拷贝默认属性值，然后和数据进行合并
          const type = item.type || pVal.defaultType // 如dataZoom，默认的对象可能没有type，但有默认值
          const model = pVal.props[type] || {
            type: 'robot',
            name: type,
            nickname: '类型',
            desc: '类型',
            isUsed: true,
            value: '',
          }
          model.value = item
          model.isUsed = true
          const data = cloneDeep(model)
          return mergeDeep(data, item)
        })
      } else if (pVal.type === 'array') { // 数组分简单数组，和复杂数组
        if (pVal.simpleArray === undefined) { // 如全局color属性，是一个简单数组，其项是一个可能是一个渐变色对象，所以不是对象都一定要递归处理
          pVal.simpleArray = oVal.every(item => !isObject(item))
        }
        if (!pVal.props) pVal.props = {}
        if (pVal.simpleArray) { // 简单数组直接使用value处理
          pVal.value = oVal.map(item => {
            const data = cloneDeep(pVal.props)
            if (!data.value) { // 初始化value对象，防止空
              data.value = {
                type: 'robot',
                name: 'value',
                nickname: '值',
                desc: '',
                isUsed: true,
              }
            }

            data.value['existInEchartsOptions'] = true // 这里做个标识，标识在解析的时候，echarts的options中有这个属性

            data.value['value'] = item
            return {
              props: data
            }
          })
        } else {
          oVal = oVal.map(item => { // 规格化数据
            if (!isObject(item)) {
              const newItem = {}
              newItem.value = item
              return newItem
            }
            return item
          })
          pVal.value = oVal.map(item => { // 复杂的则拷贝默认属性值，然后和数据进行合并
            const data = cloneDeep(pVal.props)
            const newData = mergeDeep({
              props: data,
              type: 'object',
            }, item)
            return newData
          })
        }
      }
    } else if (isObject(oVal)) { // 如果是对象，则递归进行合并
      mergeDeep(pVal, oVal);
      pVal.isUsed = true // 对象有该属性标记已经被使用
    } else { // 如果已经是叶子节点，直接拷贝值
      pVal.value = oVal
    }
    if (Array.isArray(pVal.value) || isObject(pVal.value)) {
      pVal.isUsed = true
    }
  });
  return prev
}

// 规范化echarts options
function normalizeEchartsOptions (echartsOptions = {}) {
  const options = cloneDeep(echartsOptions)
  if (isPlainObject(options.series)) {
    options.series = [options.series]
  }
  if (isPlainObject(options.xAxis)) {
    options.xAxis = [options.xAxis]
  }
  if (isPlainObject(options.yAxis)) {
    options.yAxis = [options.yAxis]
  }
  return options
}

// soul解析
export function soulParse(echartsOptions = {}) {
  const initModels = { props: cloneDeep(models) }
  const eOptions = normalizeEchartsOptions(echartsOptions)
  const data = mergeDeep(initModels, eOptions)
  return data.props
}

// 深度提取option
function makeOptionDeep (soul, isProps) {
  const data = {}
  if (isProps) { // 如果是属性
    const propsData = Object.keys(soul).reduce((val, key) => {
      return {
        ...val,
        ...makeOptionDeep(soul[key]),
      }
    }, {})
    return propsData
  } else if (soul.hasOwnProperty('isUsed') && !soul.isUsed) {
    return
  } else if (soul.type === 'robot') { // 如果是robot直接获取其值
    data[soul.name] = soul.value
  } else if (soul.type === 'object') { // 如果是对象，递归获取其值
    if (soul.isUsed) {
      data[soul.name] = makeOptionDeep(soul.props, true)
    }
  } else if (soul.type === 'typeArray') { // 如果是类型数组，则循环后递归获取
    if (soul.isUsed) {
      const newArr = soul.value.filter(item => item.isUsed)
      if (newArr.length) {
        data[soul.name] = newArr.map(subSoul => {
          // console.log('subSoul', subSoul)
          const item = makeOptionDeep(subSoul)
          return item[subSoul.name]
        })
      }
    }
  } else if (soul.type === 'array') { // 如果是数组
    if (soul.isUsed) {
      data[soul.name] = soul.value.map(subSoul => {
        const item = makeOptionDeep(subSoul.props, true)
        if (item.hasOwnProperty('value') && Object.keys(item).length === 1) { // 针对只有value属性的处理
          return item.value
        }
        return item
      })

    }
  } else if (soul.type === 'richMap') {
    if (soul.isUsed) {
      const richMapPKeyObj = Object.values(soul.props).find(item => item.richMapPrimaryKey)
      const richMapPrimaryKeyName = richMapPKeyObj.name
      data[soul.name] = soul.value.map(subSoul => {
        const item = makeOptionDeep(subSoul.props, true)
        return item
      }).reduce((val, item) => {
        // item: [{b: 1, primaryKey: "aaa"}] => { "aaa": { b: 1 } }c
        val[item[richMapPrimaryKeyName]] = Object.keys(item).reduce((val, key) => {
          if (key !== richMapPrimaryKeyName) {
            val[key] = item[key]
          }
          return val
        }, {})
        return val
      }, {})
    }
  } else if (
    // 包含type === 'pureValue'
    soul.value !== undefined &&
    soul.value !== '' &&
    soul.value !== soul.defaultValue && 
    JSON.stringify(soul.value) !== JSON.stringify(soul.defaultValue)) {
    data[soul.name] = soul.value
  }
  return data
}

// 根据soul，生成echartsOptions
export function makeECOptions (soul) {
  const initSoul = { type: 'object', name: 'root', isUsed: true, props: cloneDeep(soul) }
  const data = makeOptionDeep(initSoul)
  const options = data.root
  // 如果数组只有一个元素，变成对象
  if (options.series && options.series.length === 1) {
    options.series = options.series[0]
  }
  if (options.xAxis && options.xAxis.length === 1) {
    options.xAxis = options.xAxis[0]
  }
  if (options.yAxis && options.yAxis.length === 1) {
    options.yAxis = options.yAxis[0]
  }
  // end
  return options
}

// 生成默认的soul
export function makeInitSoul () {
  return cloneDeep(models)
}

// 遍历soul对象
export function deepWalkSoul (soul, {
  isProps = false,
  parentPath = '',
  callback = () => {},
} = {}) {
  if (!isProps) {
    parentPath = `${parentPath}.${soul.name}`
    if (soul.existInEchartsOptions) {
      // console.log(parentPath, soul.existInEchartsOptions)
    }
    callback(soul)
  }
  if (isProps) { // 如果是属性
    Object.keys(soul).forEach(key => {
      deepWalkSoul(soul[key], { isProps: false, parentPath, callback })
    })
  } else if (soul.type === 'robot') { // 如果是robot直接获取其值
  } else if (soul.type === 'pureValue') {
  } else if (soul.type === 'object') { // 如果是对象，递归获取其值
    deepWalkSoul(soul.props, { isProps: true, parentPath, callback })
  } else if (soul.type === 'typeArray') { // 如果是类型数组，则循环后递归获取
    soul.value.forEach(subSoul => {
      deepWalkSoul(subSoul, { isProps: false, parentPath, callback })
    })
  } else if (soul.type === 'array') { // 如果是数组
    soul.value.forEach(subSoul => {
      deepWalkSoul(subSoul.props, { isProps: true, parentPath, callback })
      callback(subSoul)
    })
  } else if (soul.type === 'richMap') {
    soul.value.forEach(subSoul => {
      deepWalkSoul(subSoul.props, { isProps: true, parentPath, callback })
      callback(subSoul)
    })
  }
}

export function walkSoul (soul, callback) {
  const initSoul = { type: 'object', name: 'root', isUsed: true, props: soul }
  deepWalkSoul(initSoul, { callback })
}

// const echartsOptions = {
//   xAxis: {
//     type: 'category',
//     data: [{ name: 'aa', value: 'Mon' }, 'Tue']
//   },
//   yAxis: {
//     type: 'value'
//   },
//   series: [{
//     data: [820, 932, 901, 934, 1290, 1330, 1320],
//     type: 'line'
//   }]
// }

// console.log(JSON.stringify(echartsOptions))
// const data = soulParse(echartsOptions)
// console.log('data', data)
// const options = makeECOptions(data)
// console.log('options', options)
// console.log(JSON.stringify(options))
